import * as React from "react";
import { useEffect, useState } from "react";
import { changeName } from "../../Authentication/fb";
import { User } from "./user";
import { fetchNamesFromOpenSea } from "../../Authentication/utils";

export const AccountComponent: React.FC<{
  onMenuClick?: () => void;
  expanded: boolean;
  uid: string;
  name: string;
  avatarUrl: string;

  onProfilePress: () => void;
  onSignOut: () => void;
}> = ({ expanded, onMenuClick, ...props }) => {
  const [names, setNames] = useState<string[]>([]);

  useEffect(() => {
    fetchNamesFromOpenSea(props.uid).then(setNames).catch(console.log);
  }, [props.uid]);

  return (
    <>
      <User
        names={names}
        expanded={expanded}
        online={true}
        avatar={props.avatarUrl}
        name={props.name}
        status={"#" + props.uid.slice(props.uid.length - 4, props.uid.length)}
        onNameChange={changeName}
        onMenuClick={onMenuClick}
      />
      <div
        onClick={props.onProfilePress}
        className={"mvc-account-button mvc-button"}
      >
        Profile
      </div>
      <div
        onClick={props.onSignOut}
        className={"mvc-account-button mvc-button"}
      >
        Log out
      </div>
    </>
  );
};
